// Endpoint za kreiranje statusa zuba
export const createToothStatusEndpoint = () => {
  return `/tooth-status`;
};

// Endpoint za označavanje zuba kao izvađenog
export const markToothAsExtractedEndpoint = () => {
  return `/tooth-status/extract`;
};

// Endpoint za ažuriranje statusa zuba
export const updateToothStatusEndpoint = (statusId: string) => {
  return `/tooth-status/${statusId}`;
};

// Endpoint za dohvaćanje statusa zuba klijenta
export const getClientToothStatusesEndpoint = (clientId: string) => {
  return `/tooth-status/client/${clientId}`;
};

// Endpoint za dohvaćanje najnovijeg statusa specifičnog zuba
export const getToothStatusEndpoint = (clientId: string, toothNumber: number) => {
  return `/tooth-status/${clientId}/${toothNumber}`;
};

// Endpoint za dohvaćanje povijesti statusa specifičnog zuba
export const getToothStatusHistoryEndpoint = (clientId: string, toothNumber: number) => {
  return `/tooth-status/history/${clientId}/${toothNumber}`;
}; 